import { render } from "./QuizMultiChoices.vue?vue&type=template&id=273171e3"
import script from "./QuizMultiChoices.vue?vue&type=script&lang=js"
export * from "./QuizMultiChoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__